"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function (Drupal, once) {
  'use strict';

  /** Store API paths */
  var apiPaths = {
    languages: '/ikn-custom/find-dentist/options/languages',
    specialties: '/ikn-custom/find-dentist/options/specialties',
    stateLocations: function stateLocations(state) {
      return "/ikn-custom/find-dentist/options/state-locations/".concat(encodeURIComponent(state));
    },
    cities: function cities(state) {
      return "/ikn-custom/find-dentist/options/cities/".concat(encodeURIComponent(state));
    },
    counties: function counties(state) {
      return "/ikn-custom/find-dentist/options/counties/".concat(encodeURIComponent(state));
    }
  };

  /** Store DOM selectors */
  var selectors = {
    state: 'select[name="state"]',
    stateLocation: 'select[name="statelocation"]',
    language: 'select[name="language"][data-ikn-language="1"]',
    specialty: 'select[name="specialty"][data-ikn-specialty="1"]',
    cityCountyRadios: 'input[type="radio"][name="citycounty"]',
    cityCountyChecked: 'input[type="radio"][name="citycounty"]:checked',
    cityCountySelect: 'select[name="citycountyselect"]'
  };

  /** Store shared UI values */
  var uiText = {
    emptyValue: '0',
    cityPlaceholder: function cityPlaceholder(state) {
      return "Select a City in ".concat(state);
    },
    countyPlaceholder: function countyPlaceholder(state) {
      return "Select a County in ".concat(state);
    }
  };

  /** Store abort controllers */
  var abort = {
    stateLocation: null,
    cityCounty: null
  };

  /** Fetch JSON from API */
  function fetchJson(_x) {
    return _fetchJson.apply(this, arguments);
  }
  /** Read options from payload */
  function _fetchJson() {
    _fetchJson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(url) {
      var _ref3,
        signal,
        res,
        _args3 = arguments;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _ref3 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, signal = _ref3.signal;
            _context3.n = 1;
            return fetch(url, {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json'
              },
              signal: signal
            });
          case 1:
            res = _context3.v;
            if (res.ok) {
              _context3.n = 2;
              break;
            }
            throw new Error("HTTP ".concat(res.status, " ").concat(res.statusText));
          case 2:
            return _context3.a(2, res.json());
        }
      }, _callee3);
    }));
    return _fetchJson.apply(this, arguments);
  }
  function getOptions(payload) {
    var opts = payload === null || payload === void 0 ? void 0 : payload.options;
    return opts && _typeof(opts) === 'object' ? opts : {};
  }

  /** Run async with fallback */
  function tryOr(_x2, _x3) {
    return _tryOr.apply(this, arguments);
  }
  /** Clear select options */
  function _tryOr() {
    _tryOr = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(fn, fallback) {
      var _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return fn();
          case 1:
            return _context4.a(2, _context4.v);
          case 2:
            _context4.p = 2;
            _t = _context4.v;
            if (!((_t === null || _t === void 0 ? void 0 : _t.name) === 'AbortError')) {
              _context4.n = 3;
              break;
            }
            return _context4.a(2, fallback);
          case 3:
            return _context4.a(2, fallback);
        }
      }, _callee4, null, [[0, 2]]);
    }));
    return _tryOr.apply(this, arguments);
  }
  function clearSelect(selectEl) {
    selectEl.replaceChildren();
  }

  /** Add option to select */
  function addOption(selectEl, value, label) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected;
    var opt = document.createElement('option');
    opt.value = String(value);
    opt.textContent = String(label);
    if (selected) {
      opt.selected = true;
    }
    selectEl.appendChild(opt);
  }

  /** Set disabled state */
  function setDisabled(elements, disabled) {
    elements.forEach(function (el) {
      if (el) {
        el.disabled = disabled;
      }
    });
  }

  /** Trigger change event */
  function triggerChange(el) {
    if (el) {
      el.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  }

  /** Fill select with options */
  function fillSelect(selectEl, optionsMap, placeholder) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
    clearSelect(selectEl);
    addOption(selectEl, uiText.emptyValue, placeholder, {
      selected: true
    });
    for (var _i = 0, _Object$entries = Object.entries(optionsMap || {}); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        value = _Object$entries$_i[0],
        label = _Object$entries$_i[1];
      var v = String(value);
      if (v === uiText.emptyValue) {
        continue;
      }
      addOption(selectEl, v, label);
    }
    selectEl.disabled = disabled;
  }

  /** Read city/county mode */
  function readCityCountyMode(context) {
    var checked = context.querySelector(selectors.cityCountyChecked) || document.querySelector(selectors.cityCountyChecked);
    return (checked === null || checked === void 0 ? void 0 : checked.value) === 'county' ? 'county' : 'city';
  }

  /** Load language options */
  function loadLanguages() {
    return _loadLanguages.apply(this, arguments);
  }
  /** Load specialty options */
  function _loadLanguages() {
    _loadLanguages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _t2;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _t2 = getOptions;
            _context5.n = 1;
            return fetchJson(apiPaths.languages);
          case 1:
            return _context5.a(2, _t2(_context5.v));
        }
      }, _callee5);
    }));
    return _loadLanguages.apply(this, arguments);
  }
  function loadSpecialties() {
    return _loadSpecialties.apply(this, arguments);
  }
  /** Load state location options */
  function _loadSpecialties() {
    _loadSpecialties = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _t3;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _t3 = getOptions;
            _context6.n = 1;
            return fetchJson(apiPaths.specialties);
          case 1:
            return _context6.a(2, _t3(_context6.v));
        }
      }, _callee6);
    }));
    return _loadSpecialties.apply(this, arguments);
  }
  function loadStateLocations(_x4) {
    return _loadStateLocations.apply(this, arguments);
  }
  /** Load city options */
  function _loadStateLocations() {
    _loadStateLocations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(state) {
      var _ref4,
        signal,
        _args7 = arguments,
        _t4;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _ref4 = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {}, signal = _ref4.signal;
            _t4 = getOptions;
            _context7.n = 1;
            return fetchJson(apiPaths.stateLocations(state), {
              signal: signal
            });
          case 1:
            return _context7.a(2, _t4(_context7.v));
        }
      }, _callee7);
    }));
    return _loadStateLocations.apply(this, arguments);
  }
  function loadCities(_x5) {
    return _loadCities.apply(this, arguments);
  }
  /** Load county options */
  function _loadCities() {
    _loadCities = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(state) {
      var _ref5,
        signal,
        _args8 = arguments,
        _t5;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            _ref5 = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {}, signal = _ref5.signal;
            _t5 = getOptions;
            _context8.n = 1;
            return fetchJson(apiPaths.cities(state), {
              signal: signal
            });
          case 1:
            return _context8.a(2, _t5(_context8.v));
        }
      }, _callee8);
    }));
    return _loadCities.apply(this, arguments);
  }
  function loadCounties(_x6) {
    return _loadCounties.apply(this, arguments);
  }
  /** Bind change handler once */
  function _loadCounties() {
    _loadCounties = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(state) {
      var _ref6,
        signal,
        _args9 = arguments,
        _t6;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            _ref6 = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {}, signal = _ref6.signal;
            _t6 = getOptions;
            _context9.n = 1;
            return fetchJson(apiPaths.counties(state), {
              signal: signal
            });
          case 1:
            return _context9.a(2, _t6(_context9.v));
        }
      }, _callee9);
    }));
    return _loadCounties.apply(this, arguments);
  }
  function bindOnce(el, key, handler) {
    if (!el || el.dataset[key] === '1') {
      return;
    }
    el.addEventListener('change', handler);
    el.dataset[key] = '1';
  }

  /** Read state-location no-state label */
  function readStateLocationNoState(stateLocationEl) {
    var _stateLocationEl$data, _stateLocationEl$data2;
    return (_stateLocationEl$data = stateLocationEl === null || stateLocationEl === void 0 || (_stateLocationEl$data2 = stateLocationEl.dataset) === null || _stateLocationEl$data2 === void 0 ? void 0 : _stateLocationEl$data2.placeholderNoState) !== null && _stateLocationEl$data !== void 0 ? _stateLocationEl$data : 'Select a Dentist State';
  }

  /** Read state-location active label */
  function readStateLocationWithState(stateLocationEl) {
    var _stateLocationEl$data3, _stateLocationEl$data4;
    return (_stateLocationEl$data3 = stateLocationEl === null || stateLocationEl === void 0 || (_stateLocationEl$data4 = stateLocationEl.dataset) === null || _stateLocationEl$data4 === void 0 ? void 0 : _stateLocationEl$data4.placeholderWithState) !== null && _stateLocationEl$data3 !== void 0 ? _stateLocationEl$data3 : 'Select a dentist location state';
  }

  /** Read city/county empty label */
  function readCityCountyPlaceholder(cityCountySelectEl) {
    var _cityCountySelectEl$d, _cityCountySelectEl$d2;
    return (_cityCountySelectEl$d = cityCountySelectEl === null || cityCountySelectEl === void 0 || (_cityCountySelectEl$d2 = cityCountySelectEl.dataset) === null || _cityCountySelectEl$d2 === void 0 ? void 0 : _cityCountySelectEl$d2.placeholder) !== null && _cityCountySelectEl$d !== void 0 ? _cityCountySelectEl$d : 'Select a dentist location state first';
  }

  /** Fetch state-location options safely */
  function fetchStateLocationOptions(_x7) {
    return _fetchStateLocationOptions.apply(this, arguments);
  }
  /** Fetch city/county options safely */
  function _fetchStateLocationOptions() {
    _fetchStateLocationOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(state) {
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            if (abort.stateLocation) {
              abort.stateLocation.abort();
            }
            abort.stateLocation = new AbortController();
            return _context0.a(2, tryOr(function () {
              return loadStateLocations(state, {
                signal: abort.stateLocation.signal
              });
            }, {}));
        }
      }, _callee0);
    }));
    return _fetchStateLocationOptions.apply(this, arguments);
  }
  function fetchCityCountyOptions(_x8, _x9) {
    return _fetchCityCountyOptions.apply(this, arguments);
  }
  /** Hydrate static select options */
  function _fetchCityCountyOptions() {
    _fetchCityCountyOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(state, mode) {
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            if (abort.cityCounty) {
              abort.cityCounty.abort();
            }
            abort.cityCounty = new AbortController();
            if (!(mode === 'county')) {
              _context1.n = 1;
              break;
            }
            return _context1.a(2, tryOr(function () {
              return loadCounties(state, {
                signal: abort.cityCounty.signal
              });
            }, {}));
          case 1:
            return _context1.a(2, tryOr(function () {
              return loadCities(state, {
                signal: abort.cityCounty.signal
              });
            }, {}));
        }
      }, _callee1);
    }));
    return _fetchCityCountyOptions.apply(this, arguments);
  }
  function hydrateStaticSelect(selects, loader, fallbackPlaceholder) {
    selects.forEach(function (selectEl) {
      var _selectEl$options$;
      if (selectEl.options.length > 1) {
        return;
      }
      var placeholder = ((_selectEl$options$ = selectEl.options[0]) === null || _selectEl$options$ === void 0 ? void 0 : _selectEl$options$.textContent) || fallbackPlaceholder;
      tryOr(loader, {}).then(function (opts) {
        fillSelect(selectEl, opts, placeholder);
      });
    });
  }
  Drupal.behaviors.iknAdvancedOptions = {
    /** Attach advanced options behavior */attach: function attach(context) {
      hydrateStaticSelect(once('iknLang', selectors.language, context), loadLanguages, 'English');
      hydrateStaticSelect(once('iknSpec', selectors.specialty, context), loadSpecialties, 'All dentists who serve children');
      var stateEl = context.querySelector(selectors.state);
      var stateLocationEl = context.querySelector(selectors.stateLocation);
      var cityCountySelectEl = context.querySelector(selectors.cityCountySelect);

      /** Refresh city/county options */
      function refreshCityCounty() {
        return _refreshCityCounty.apply(this, arguments);
      }
      /** Refresh state location options */
      function _refreshCityCounty() {
        _refreshCityCounty = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var radios, state, mode, placeholder, opts;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(!cityCountySelectEl || !stateLocationEl)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                radios = Array.from(context.querySelectorAll(selectors.cityCountyRadios));
                state = String(stateLocationEl.value || uiText.emptyValue);
                if (!(state === uiText.emptyValue)) {
                  _context.n = 2;
                  break;
                }
                setDisabled(radios, true);
                fillSelect(cityCountySelectEl, {}, readCityCountyPlaceholder(cityCountySelectEl), {
                  disabled: true
                });
                return _context.a(2);
              case 2:
                setDisabled(radios, false);
                mode = readCityCountyMode(context);
                placeholder = mode === 'county' ? uiText.countyPlaceholder(state) : uiText.cityPlaceholder(state);
                fillSelect(cityCountySelectEl, {}, placeholder, {
                  disabled: true
                });
                _context.n = 3;
                return fetchCityCountyOptions(state, mode);
              case 3:
                opts = _context.v;
                fillSelect(cityCountySelectEl, opts, placeholder);
              case 4:
                return _context.a(2);
            }
          }, _callee);
        }));
        return _refreshCityCounty.apply(this, arguments);
      }
      function refreshStateLocation() {
        return _refreshStateLocation.apply(this, arguments);
      }
      function _refreshStateLocation() {
        _refreshStateLocation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var state, opts;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!(!stateEl || !stateLocationEl)) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                state = String(stateEl.value || uiText.emptyValue);
                if (!(state === uiText.emptyValue)) {
                  _context2.n = 2;
                  break;
                }
                fillSelect(stateLocationEl, {}, readStateLocationNoState(stateLocationEl), {
                  disabled: true
                });
                triggerChange(stateLocationEl);
                return _context2.a(2);
              case 2:
                fillSelect(stateLocationEl, {}, readStateLocationWithState(stateLocationEl), {
                  disabled: true
                });
                _context2.n = 3;
                return fetchStateLocationOptions(state);
              case 3:
                opts = _context2.v;
                fillSelect(stateLocationEl, opts, readStateLocationWithState(stateLocationEl));
                triggerChange(stateLocationEl);
              case 4:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return _refreshStateLocation.apply(this, arguments);
      }
      var formEl = stateEl === null || stateEl === void 0 ? void 0 : stateEl.closest('form');
      if (formEl && formEl.dataset.iknAdvancedResetBound !== '1') {
        formEl.addEventListener('reset', function () {
          window.setTimeout(function () {
            refreshStateLocation();
            refreshCityCounty();
          }, 0);
        });
        formEl.dataset.iknAdvancedResetBound = '1';
      }
      if (stateEl && stateLocationEl) {
        bindOnce(stateEl, 'iknStateLocBound', refreshStateLocation);
        refreshStateLocation();
      }
      if (!cityCountySelectEl || !stateLocationEl) {
        return;
      }
      once('iknCityCountyRadios', selectors.cityCountyRadios, context).forEach(function (radio) {
        radio.addEventListener('change', refreshCityCounty);
      });
      bindOnce(stateLocationEl, 'iknCityCountyBound', refreshCityCounty);
      refreshCityCounty();
    }
  };
})(Drupal, once);